import { AssetBody } from '@/shared/types/assets/assets.types.ts';

/**
 * Determines if an asset is a crane based on:
 * 1. "Crane" in the asset's categoryPath or subtype
 * 2. Has "loaded" extra property
 */
export const isCraneAsset = (asset: AssetBody | undefined): boolean => {
  if (!asset) return false;

  // Check if "Crane" is in the subtype
  const hasCraneInSubtype = asset.subType?.toLowerCase().includes('crane') ?? false;

  // Check if asset has "loaded" extra property
  // extraProperties is an array of objects with structure: {key: string, value: string}
  const hasLoadedProperty = asset.extraProperties?.some(prop => prop.key === 'loaded') ?? false;

  return hasCraneInSubtype || hasLoadedProperty;
};

/**
 * Gets the loaded status of a crane asset
 * Returns true if loaded, false if unloaded, undefined if not a crane or status not set
 */
export const getCraneLoadedStatus = (asset: AssetBody | undefined): boolean | undefined => {
  if (!asset || !isCraneAsset(asset)) return undefined;

  // Check extraProperties array format: {key: string, value: string}[]
  const loadedProperty = asset.extraProperties?.find(prop => prop.key === 'loaded');
  if (loadedProperty && loadedProperty.value) {
    const loadedValue = loadedProperty.value;
    if (typeof loadedValue === 'string') {
      return loadedValue.toLowerCase() === 'true';
    }
    if (typeof loadedValue === 'boolean') {
      return loadedValue;
    }
  }

  return undefined;
};
